import ErrorSamplePage from "./ErrorSamplePage";

export {ErrorSamplePage}
export default ErrorSamplePage
